import type { CollectionTreeModel } from './CollectionTreeModel'
import type { PopoverHooks } from '../../core/popover/popover-hooks.tsx'
import type { NewNodePopoverResult } from './NewNodePopoverItems.tsx'
import type { NodeOptionPopoverItem } from './HierarchyNodeOptionsPopoverItemsProps.tsx'
import { createContext } from 'react'
import type { CollectionModel } from '@/core/gql/gql-models-override.ts'

export interface ICollectionTreeContext {
  tree: CollectionTreeModel
  onCollectionClicked: (collection: CollectionModel) => void
  newNodePopoverHooks: PopoverHooks<NewNodePopoverResult>
  optionPopoverHooks: PopoverHooks<NodeOptionPopoverItem>
}

export const CollectionTreeContext = createContext<ICollectionTreeContext | undefined>(undefined)
